import type { ConfluenceFooterComment } from '../../types';

export const isConfluenceFooterComment = (entity: any): entity is ConfluenceFooterComment =>
	entity.__typename === 'ConfluenceFooterComment';

export const getConfluenceFooterCommentLink = (comment: ConfluenceFooterComment): string | null => {
	const { base, webUi } = comment.links ?? {};

	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}

	return `${base}${webUi}`;
};
